import { useState, useEffect, ChangeEvent } from "react";
import { Button, SvgIcon } from "@mui/material";

import "./style.scss";
import { ReactComponent as RocketIcon } from "../../../assets/rocket-gradient.icon.svg";
import { FirebaseAuthContainer } from "../../../common/containers/auth/firebase-auth-container.util";

const FeedbackView = ({ handleClose }: { handleClose: () => void }) => {
    const { user } = FirebaseAuthContainer.useContainer();
    const [message, setMessage] = useState<string>("");
    const [description, setDescription] = useState<string>();
    const title = `Upgrade to Full Version
    or want to know more?`;

    useEffect(() => {
        if (!user) return;

        setDescription(
            `${user.firstName ?? user.email}, If you wish to comment or ask anything, please do. We will contact you shortly!`
        );
    }, [user]);

    const handleCloseClick = () => {
        handleClose();
    };

    const handleTextChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        setMessage(event.target.value);
    };

    const handleSendRequestClick = () => {
        // TODO functionality will be added
        handleCloseClick();
    };

    return (
        <div className="feedback">
            <div className="feedback-title">
                <SvgIcon className="feedback-title__icon" component={RocketIcon} inheritViewBox />
                <span className="feedback-title__text">{title}</span>
            </div>
            <div className="feedback-description">{description}</div>
            <textarea
                className="feedback-message"
                onChange={handleTextChange}
                placeholder="Message"
                value={message}
            />
            <div className="feedback-action">
                <Button className="secondary-button" variant="outlined" onClick={handleCloseClick}>
                    Cancel
                </Button>
                <Button
                    className="primary-button feedback-action__button-margin"
                    variant="outlined"
                    disabled={!message}
                    onClick={handleSendRequestClick}
                >
                    Send Request
                </Button>
            </div>
        </div>
    );
};

export default FeedbackView;
